<template>
    <DCard
        :title="$t('common.create')"
        padding
    >
        <Form
            :available-permissions="availablePermissions"
            :errors="errors"
            @save-role="saveRole"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Roles/Form'
import { router } from '@inertiajs/vue3'

export default {
    name: 'RoleCreate',
    components: { Form },
    props: {
        availablePermissions: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    methods: {
        saveRole (data) {
            router.post(this.$route('roles.store'), data)
        }
    }
}
</script>

<style scoped>

</style>
